import { LandingPageCropControl } from './landing-page-crop-control'

export function LandingPageBackdropLayerControls() {
	return (
		<div className="text-left mb-4">
			<LandingPageCropControl />
		</div>
	)
}
